// Volumental partner-studio upload: one mesh per foot, stored under a fixed
// name in the side folder (`left/model_l.stl`, `right/model_r.stl`), the same
// layout the old Footscan scans had. The studio never has to care about file
// names, and the names always pass hezo-ops's filename check (ASCII, no
// spaces), which a studio's own file names did not.

import { inferContentType } from "./fake-content";
import type { RunInput } from "./upload-pipeline";

export type VolumentalSide = "left" | "right";

/** Meshes the pipeline downstream can read; STL is the normal case. */
export const VOLUMENTAL_ACCEPT = ".stl,.obj";

/** Lower-cased extension (`stl` | `obj`), or null for anything else. */
export function volumentalExtension(file: { name: string }): "stl" | "obj" | null {
  const m = file.name.toLowerCase().match(/\.(stl|obj)$/);
  return m ? (m[1] as "stl" | "obj") : null;
}

/** Fixed S3 name for a side's mesh, or null when the extension is not allowed. */
export function volumentalTargetName(
  side: VolumentalSide,
  file: { name: string },
): string | null {
  const ext = volumentalExtension(file);
  if (!ext) return null;
  return side === "left" ? `left/model_l.${ext}` : `right/model_r.${ext}`;
}

/** Pipeline inputs for the two picked meshes, left first. */
export function volumentalInputs(left: File, right: File): RunInput[] {
  const pairs: Array<[VolumentalSide, File]> = [
    ["left", left],
    ["right", right],
  ];
  return pairs.map(([side, file]) => {
    const filename = volumentalTargetName(side, file);
    if (!filename) throw new Error(`Unsupported mesh file: ${file.name}`);
    return { blob: file, filename, contentType: inferContentType(filename) };
  });
}
